<div class="createAudit">
  <p-dialog header="Header" (onHide)="dialogClose()" [modal]="true" [(visible)]="isShowModal"
            [style]="{width: '35.5rem'}">
    <ng-template pTemplate="header">
      <div class="d-flex align-items-center" [style]="{paddingBottom: '0px'}">
        <div class="left-border left-border-bg"></div>
        <div class="d-flex-d-column margin-left-5">
          <span class="user-title-text">Database Similarities</span>
        </div>
      </div>
    </ng-template>
    <p-divider></p-divider>

    <div>
      <p class="para-text">
        Find all DB Similarities in one place.
      </p>
      <p-divider></p-divider>
      <div class="input-box">
        <label class="mb-3">
          Select Columns to Exclude (To remove the noise from the results (i.e., "ID, NAME, CREATED_DATE, etc") - common columns that lots of tables share)
        </label>
        <span class="p-input-icon-right input-container">
          <p-multiSelect [options]="columns"
                         optionLabel="Name"
                         defaultLabel="Choose columns"
                         display="chip"
                         styleClass="horizontal-multiselect"
                         [(ngModel)]="selectedColumns">
          </p-multiSelect>
        </span>
      </div>
      <p-divider></p-divider>
      <br style="clear:both !important;" />
      <br style="clear:both !important;" />
      <br style="clear:both !important;" />
      <br style="clear:both !important;" />
      <br style="clear:both !important;" />
      <br style="clear:both !important;" />
      <br style="clear:both !important;" />
      <br style="clear:both !important;" />
      <br style="clear:both !important;" />
      <br style="clear:both !important;" />
      <p-divider></p-divider>
    </div>

    <!-- Bottom buttons -->
    <div class="btn-box">
      <!-- Create button -->
      <p-button [loading]="false"
                class="filled-btn"
                label="Find"
                (onClick)="startSearch()" severity="secondary"></p-button>

      <!-- Add reset & Cancel button code here  -->
      <p-button class="outlined-btn reset-btn"
                [loading]="false"
                label="Reset"
                (onClick)="resetSearch()"></p-button>
    </div>
  </p-dialog>
</div>
